module.exports = __webpack_public_path__ + "static/media/List_DISH.f8e1bb39.mp3";